import React from 'react';
import Icon from "./Icon";

class Delete extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(Icon, this.props, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "#BFC6D1",
      className: "icon__fill",
      d: "M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"
    })));
  }

}

export default Delete;